import ReportsapiClient from '@/services/ReportsapiClient'
export default {
    /**
     * sales by customer report api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    //reports api call's
    getSalesByCustomer(page, count, sort, label, token, query) {

        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/customer/index/' + page + '/' + count + filter)
    },
    getSalesByCustomerExport(page, count, sort, label, token, query) {

        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/customer/export/' + page + '/' + count + filter)
    },
    getSalesByCustomerDetail(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + search + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/customer/cusdetails/' + page + '/' + count + filter)
    },
    getSalesByCustomerDetailExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + search + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/customer/cusdetailsexport/' + page + '/' + count + filter)
    },
    //  sales order by customer
    getSoByCus(page, count, sort, label, token, query) {

        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var status = typeof query.status != 'undefined' && query.status != '' ? '&status=' + query.status : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + status + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/cussalesorder/index/' + page + '/' + count + filter)
    },
    getSoByCusExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var status = typeof query.status != 'undefined' && query.status != '' ? '&status=' + query.status : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + status + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/cussalesorder/export/' + page + '/' + count + filter)
    },
    getSoByCusDetail(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        var status = typeof query.status != 'undefined' && query.status != '' ? '&status=' + query.status : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + search + status + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/cussalesorder/saldetails/' + page + '/' + count + filter)
    },
    getSoByCusDetailExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        var status = typeof query.status != 'undefined' && query.status != '' ? '&status=' + query.status : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + search + status + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/cussalesorder/saldetailsexport/' + page + '/' + count + filter)
    },
    /**
     * gst filing api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    postGstFilingOverview(page, count, sort, label, token, query) {

        var filter = '?sort=' + sort + '&label=' + label;
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var type = typeof query.type != 'undefined' && query.type != '' ? '&type=' + query.type : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&month=' + query.month + '&year=' + query.year + type;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.post('/invoice/gstfiling/' + page + '/' + count + filter)
    },

    /**
     * gst filing 
     * @param {*} token 
     * @param {*} query 
     */
    postGstFilingOverall(token, query) {
        var filter = '';
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        if (query_string == 1) {
            filter = '?type=' + query.type + '&month=' + query.month + '&year=' + query.year;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.post('/invoice/gstfiling/gstxlfiling' + filter)
    },
    /**
     * sales by product report api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getSalesByProduct(page, count, sort, label, token, query) {

        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var sales_person = typeof query.sales_person != 'undefined' && query.sales_person != '' ? '&sales_person=' + query.sales_person : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + sales_tags + sales_person;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/products/index/' + page + '/' + count + filter)
    },
    getSalesByProductExport(page, count, sort, label, token, query) {

        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var sales_person = typeof query.sales_person != 'undefined' && query.sales_person != '' ? '&sales_person=' + query.sales_person : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + sales_tags + sales_person;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/products/export/' + page + '/' + count + filter)
    },

    getSalesByProductDetail(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var sales_person = typeof query.sales_person != 'undefined' && query.sales_person != '' ? '&sales_person=' + query.sales_person : ''
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + search + sales_tags + sales_person;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/products/pdtdetails/' + page + '/' + count + filter)
    },
    getSalesByProductDetailExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var sales_person = typeof query.sales_person != 'undefined' && query.sales_person != '' ? '&sales_person=' + query.sales_person : ''
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + search + sales_tags + sales_person;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/products/pdtdetailsexport/' + page + '/' + count + filter)
    },
    /**
     * sales by sales person reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getSalesBySalesPerson(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/salperson/index/' + page + '/' + count + filter)
    },
    getSalesBySalesPersonExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/salperson/export/' + page + '/' + count + filter)
    },

    getSalesBySalesPersonDetail(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + search + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/salperson/salprsndetails/' + page + '/' + count + filter)
    },
    getSalesBySalesPersonDetailExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var sales_tags = typeof query.sales_tags != 'undefined' && query.sales_tags != '' ? '&sales_tags=' + query.sales_tags : ''
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + search + sales_tags;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/salperson/salprsndetailsexport/' + page + '/' + count + filter)
    },
    /**
     * sales by invoice reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getSalesByInvoice(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/invoice/index/' + page + '/' + count + filter)
    },
    getSalesByInvoiceExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/invoice/export/' + page + '/' + count + filter)
    },
    /**
     * sales by estimate reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getSalesByEstimate(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/estimate/index/' + page + '/' + count + filter)
    },
    getSalesByEstimateExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/estimate/export/' + page + '/' + count + filter)
    },
    /**
     * sales by payment reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getSalesByPayment(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&select_columns=' + query.select_columns + '&custom=' + query.custom + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/payment/index/' + page + '/' + count + filter)
    },
    getSalesByPaymentExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&select_columns=' + query.select_columns + '&custom=' + query.custom + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/payment/export/' + page + '/' + count + filter)
    },
    /**
     * aginag details reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getAgingDetails(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var interval_range = typeof query.interval_range != 'undefined' ? '&interval_range=' + query.interval_range : '';
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        var value = typeof query.value != 'undefined' && query.value != '' ? '&value=' + query.value : ''
        var report_date = typeof query.report_date != 'undefined' && query.report_date != '' ? '&report_date=' + query.report_date : ''
        var number_of_columns = typeof query.interval_range != 'undefined' ? '&number_of_columns=' + query.number_of_columns : '';

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&' + report_date + '&filter_by=' + query.filter_by + '&select_columns=' + query.select_columns + interval_range + number_of_columns + group_by + value;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/agingdetails/' + page + '/' + count + filter)
    },
    getAmcContract(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;

        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        return ReportsapiClient.get('/invoice/amc/index/' + page + '/' + count + filter)
    },
    getAgingDetailsExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var interval_range = typeof query.interval_range != 'undefined' ? '&interval_range=' + query.interval_range : '';
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        var value = typeof query.value != 'undefined' && query.value != '' ? '&value=' + query.value : ''
        var report_date = typeof query.report_date != 'undefined' && query.report_date != '' ? '&report_date=' + query.report_date : ''
        var number_of_columns = typeof query.interval_range != 'undefined' ? '&number_of_columns=' + query.number_of_columns : '';

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&' + report_date + '&filter_by=' + query.filter_by + interval_range + number_of_columns + '&select_columns=' + query.select_columns + group_by + value;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/agingdetails/export/' + page + '/' + count + filter)
    },
    /**
     * sales by credit reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getSalesByCredit(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&select_columns=' + query.select_columns + '&custom=' + query.custom + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/credits/index/' + page + '/' + count + filter)
    },
    getSalesByCreditExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&select_columns=' + query.select_columns + '&custom=' + query.custom + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/credits/export/' + page + '/' + count + filter)
    },
    /**
     * sales by retainer reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getSalesByRetainer(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/retainer/index/' + page + '/' + count + filter)
    },
    getSalesByRetainerExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/retainer/export/' + page + '/' + count + filter)
    },
    /**
     * sales by customer balances reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getCustomerBalances(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var show_by = typeof query.show_by != 'undefined' && query.show_by != '' ? '&show_by=' + query.show_by : ''
        var report_date = typeof query.report_date != 'undefined' && query.report_date != '' ? '&report_date=' + query.report_date : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&select_columns=' + query.select_columns + '&' + show_by + report_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/cusbalance/index/' + page + '/' + count + filter)
    },
    getCustomerBalancesExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var show_by = typeof query.show_by != 'undefined' && query.show_by != '' ? '&show_by=' + query.show_by : ''
        var report_date = typeof query.report_date != 'undefined' && query.report_date != '' ? '&report_date=' + query.report_date : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&' + '&select_columns=' + query.select_columns + show_by + report_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/cusbalance/export/' + page + '/' + count + filter)
    },
    getCustomerBalanceFilterDetail(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var filter_by = typeof query.filter_by != 'undefined' && query.filter_by != '' ? '&filter_by=' + query.filter_by : ''
        var report_date = typeof query.report_date != 'undefined' && query.report_date != '' ? '&report_date=' + query.report_date : ''
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&select_columns=' + query.select_columns + search + filter_by + report_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/cusbalance/cusbaldetails/' + page + '/' + count + filter)
    },
    getCustomerBalanceFilterDetailExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var filter_by = typeof query.filter_by != 'undefined' && query.filter_by != '' ? '&filter_by=' + query.filter_by : ''
        var report_date = typeof query.report_date != 'undefined' && query.report_date != '' ? '&report_date=' + query.report_date : ''
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&select_columns=' + query.select_columns + search + filter_by + report_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/cusbalance/cusbaldetailsexport/' + page + '/' + count + filter)
    },
    /**
     *payemtns received reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getPaymentsReceived(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var show_by = typeof query.show_by != 'undefined' && query.show_by != '' ? '&show_by=' + query.show_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + show_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/paymentreceive/index/' + page + '/' + count + filter)
    },
    getPaymentsReceivedExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var show_by = typeof query.show_by != 'undefined' && query.show_by != '' ? '&show_by=' + query.show_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + show_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/paymentreceive/export/' + page + '/' + count + filter)
    },

    /**
     *Refund History received reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getRefundHistory(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/refund/index/' + page + '/' + count + filter)
    },
    getRefundHistoryExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/refund/export/' + page + '/' + count + filter)
    },
    /**
     * sales by retainer reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getRecurringInvoiceReport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var report_by = typeof query.report_by != 'undefined' && query.report_by != '' ? '&report_by=' + query.report_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + report_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/recurring/index/' + page + '/' + count + filter)
    },
    getRecurringInvoiceReportExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var report_by = typeof query.report_by != 'undefined' && query.report_by != '' ? '&report_by=' + query.report_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + report_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/recurring/export/' + page + '/' + count + filter)
    },
    /**
     * TDSDetails reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getTDSDetails(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/withholdtax/index/' + page + '/' + count + filter)
    },
    getTdsDetailsExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/withholdtax/export/' + page + '/' + count + filter)
    },
    getTdsDetailfilterLists(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + search;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.post('/invoice/withholdtax/withholdtax/' + page + '/' + count + filter)
    },
    getTdsDetailfilterListsExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.post('/invoice/withholdtax/withholdtaxexport/' + page + '/' + count + filter)
    },
    getBankCharges(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/bankcharges/index/' + page + '/' + count + filter)
    },
    getBankChargesExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/bankcharges/export/' + page + '/' + count + filter)
    },
    getBankChargesfilterLists(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var search = typeof query.search != 'undefined' && query.search != '' ? '&search=' + query.search : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + search;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.post('/invoice/bankcharges/bankcharges/' + page + '/' + count + filter)
    },
    getBankChargesfilterListsExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&id=' + query.id + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.post('/invoice/bankcharges/bankchargesexport/' + page + '/' + count + filter)
    },
    /**
     * sales by customer balances reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getInventory(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var pdt_id = typeof query.pdt_id != 'undefined' && query.pdt_id != '' ? '&pdt_id=' + query.pdt_id : ''
        var inventory_date = typeof query.inventory_date != 'undefined' && query.inventory_date != '' ? '&inventory_date=' + query.inventory_date : ''
        var pdtstatus = typeof query.pdtstatus != 'undefined' && query.pdtstatus != '' ? '&pdtstatus=' + query.pdtstatus : ''
        var category = typeof query.category != 'undefined' && query.category != '' ? '&category=' + query.category : ''
        var warehouse_id = typeof query.warehouse_id != 'undefined' && query.warehouse_id != '' ? '&warehouse_id=' + query.warehouse_id : ''
        var show_actual_stock = typeof query.show_actual_stock != 'undefined' && query.show_actual_stock != '' ? '&show_actual_stock=' + query.show_actual_stock : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&' + pdt_id + inventory_date + pdtstatus + category + warehouse_id + show_actual_stock;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/inventorysummary/index/' + page + '/' + count + filter)
    },
    getInventoryExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var pdt_id = typeof query.pdt_id != 'undefined' && query.pdt_id != '' ? '&pdt_id=' + query.pdt_id : ''
        var inventory_date = typeof query.inventory_date != 'undefined' && query.inventory_date != '' ? '&inventory_date=' + query.inventory_date : ''
        var pdtstatus = typeof query.pdtstatus != 'undefined' && query.pdtstatus != '' ? '&pdtstatus=' + query.pdtstatus : ''
        var category = typeof query.category != 'undefined' && query.category != '' ? '&category=' + query.category : ''
        var warehouse_id = typeof query.warehouse_id != 'undefined' && query.warehouse_id != '' ? '&warehouse_id=' + query.warehouse_id : ''
        var show_actual_stock = typeof query.show_actual_stock != 'undefined' && query.show_actual_stock != '' ? '&show_actual_stock=' + query.show_actual_stock : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&' + pdt_id + inventory_date + pdtstatus + category + warehouse_id + show_actual_stock;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/inventorysummary/export/' + page + '/' + count + filter)
    },
    getStockSummary(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var warehouse_id = typeof query.warehouse_id != 'undefined' && query.warehouse_id != '' ? '&warehouse_id=' + query.warehouse_id : ''
        var pdtstatus = typeof query.pdtstatus != 'undefined' && query.pdtstatus != '' ? '&pdtstatus=' + query.pdtstatus : ''
        var pdt_id = typeof query.pdt_id != 'undefined' && query.pdt_id != '' ? '&pdt_id=' + query.pdt_id : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + pdt_id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + warehouse_id + pdtstatus;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/stocksummary/index/' + page + '/' + count + filter)
    },
    getstocksummaryExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var warehouse_id = typeof query.warehouse_id != 'undefined' && query.warehouse_id != '' ? '&warehouse_id=' + query.warehouse_id : ''
        var pdtstatus = typeof query.pdtstatus != 'undefined' && query.pdtstatus != '' ? '&pdtstatus=' + query.pdtstatus : ''
        var pdt_id = typeof query.pdt_id != 'undefined' && query.pdt_id != '' ? '&pdt_id=' + query.pdt_id : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + pdt_id + '&from_date=' + query.from_date + '&to_date=' + query.to_date + warehouse_id + pdtstatus;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/stocksummary/export/' + page + '/' + count + filter)
    },
    getPackages(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var status = typeof query.status != 'undefined' && query.status != '' ? '&status=' + query.status : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + status;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/package/index/' + page + '/' + count + filter)
    },
    getPackagesExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var status = typeof query.status != 'undefined' && query.status != '' ? '&status=' + query.status : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + status;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/package/export/' + page + '/' + count + filter)
    },
    getSalesOrder(page, count, sort, label, token, query) {

        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var warehouse = typeof query.warehouse != 'undefined' && query.warehouse != '' ? '&warehouse=' + query.warehouse : ''
        var status = typeof query.status != 'undefined' && query.status != '' ? '&status=' + query.status : ''
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + warehouse + status + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/salorder/index/' + page + '/' + count + filter)
    },
    getSalesOrderExport(page, count, sort, label, token, query) {

        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var warehouse = typeof query.warehouse != 'undefined' && query.warehouse != '' ? '&warehouse=' + query.warehouse : ''
        var status = typeof query.status != 'undefined' && query.status != '' ? '&status=' + query.status : ''
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + warehouse + status + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/salorder/export/' + page + '/' + count + filter)
    },
    getReceive(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;


        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/receive/index/' + page + '/' + count + filter)
    },
    getReceiveExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/receive/export/' + page + '/' + count + filter)
    },
    getReturn(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/salesreturn/index/' + page + '/' + count + filter)
    },
    getFulfillment(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/orderfullfilled/index/' + page + '/' + count + filter)
    },
    getFulfillmentExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/orderfullfilled/export/' + page + '/' + count + filter)
    },
    getwarehouseDetails(token) {
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/warehouse/details')
    },
    getwarehouse(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var show_actual_stock = typeof query.show_actual_stock != 'undefined' & query.show_actual_stock != '' ? '&show_actual_stock=' + query.show_actual_stock : ''
        var pdt_id = typeof query.pdt_id != 'undefined' && query.pdt_id != '' ? '&pdt_id=' + query.pdt_id : ''
        var pdtstatus = typeof query.pdtstatus != 'undefined' && query.pdtstatus != '' ? '&pdtstatus=' + query.pdtstatus : ''
        var user_invtry_date = typeof query.user_invtry_date != 'undefined' & query.user_invtry_date != '' ? '&user_invtry_date=' + query.user_invtry_date : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + pdt_id + pdtstatus + '&inventory_date=' + query.inventory_date + show_actual_stock;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/warehouse/index/' + page + '/' + count + filter)
    },
    getwarehouseExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var show_actual_stock = typeof query.show_actual_stock != 'undefined' & query.show_actual_stock != '' ? '&show_actual_stock=' + query.show_actual_stock : ''
        var pdtstatus = typeof query.pdtstatus != 'undefined' && query.pdtstatus != '' ? '&pdtstatus=' + query.pdtstatus : ''
        var pdt_id = typeof query.pdt_id != 'undefined' && query.pdt_id != '' ? '&pdt_id=' + query.pdt_id : ''
        var user_invtry_date = typeof query.user_invtry_date != 'undefined' & query.user_invtry_date != '' ? '&user_invtry_date=' + query.user_invtry_date : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + pdt_id + pdtstatus + '&inventory_date=' + query.inventory_date + show_actual_stock;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/warehouse/export/' + page + '/' + count + filter)
    },
    getWarehouseDetails(token) {
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/sales/warehouse/details')
    },
    getGstLists(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/invgstreports/index/' + page + '/' + count + filter)
    },
    getSalesgstExport(page, count, query, token) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        if (query_string == 1) {
            var filter = '?type=' + query.type + '&month=' + query.month + '&year=' + query.year;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/invoice/gstreports/export/' + page + '/' + count + filter)
    },

}